module.exports = __webpack_public_path__ + "img/image-4.755106a4.svg";